import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["toggleableFields", "toggleButton"];

    connect() {
        this.showingMore = false;
    }

    toggle(event) {
        const button = event.currentTarget;
        const icon = button.querySelector('i, svg');
        const settings = button.dataset.settings;
        const container = button.closest('.toggle-data');

        if (settings === "otherSettings") {
            if (icon) icon.classList.toggle('rotate-180');
        } else {
            this.showingMore = !this.showingMore;
            button.textContent = this.showingMore ? "Show Less" : "Show More";

        }
        container.querySelectorAll('.toggleable').forEach((field) => {
            field.classList.toggle('hidden');
        });
    }
}



